import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/base-styles/reset.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/base-styles/base.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(embeds)/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/datadog/rum-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/apollo/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/segment/AnalyticsContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/segment/AnalyticsProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/segment/components/segment-event-viewed/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/segment/components/segment-page-view/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SegmentPageViewContext"] */ "/app/src/lib/segment/components/segment-page-view/segment-page-view-context.ts");
;
import(/* webpackMode: "eager" */ "/app/src/lib/segment/SegmentGlobalOptions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/app-version-debugger-styles.scss");
